import { createSlice } from "@reduxjs/toolkit"
import { apiSlice } from "app/api/apiSlice"

const authSlice = createSlice({
    name: 'auth',
    initialState: { user: null, token: null, company: null, permissions:[] },
    reducers: {
        setCredentials: (state, action) => {
           
            const { user, token, claims } = action.payload
            state.user = user
            state.token = token
            state.claims = claims
            if(action.payload.store){
                localStorage.setItem("authToken", token); // Usa sessionStorage.setItem se vuoi che sia temporaneo
            }
            
        },
        setUserInfo: (state, action) => {
            state.displayname = action.payload.name? action.payload.name + " " + action.payload.surname : state.user
            state.firstname = action.payload.name || state.user
            state.lastname = action.payload.surname
            state.guid = action.payload.guid
        },
        setCompany: (state, action) => {
            state.company = {
                guid : action.payload.guid,
                img : action.payload.img
            }
            //state.company.guid = action.payload.guid
        },
        setPermissions: (state, action) => {
            state.permissions = action.payload
        },
        logOut: (state, action) => {
            localStorage.removeItem("authToken");
            state.user = null
            state.token = null
            state.permissions = null
            state.licenseExpired = null
        },
        licenseExpired: (state, action) => {
            state.licenseExpired = true
        }
    },
})

export const { setCredentials, setCompany, setUserInfo, setPermissions, logOut, licenseExpired, licenseRefreshed } = authSlice.actions

// Thunk per eseguire logOut e resettare l'API state
export const logOutAndResetApi = () => (dispatch) => {
    dispatch(authSlice.actions.logOut());
    dispatch(apiSlice.util.resetApiState());
};

export default authSlice.reducer

export const selectCurrentUser = (state) => state.auth.user
export const selectCurrentToken = (state) => state.auth.token
export const selectCurrentClaims = (state) => state.auth.claims
export const selectCurrentUserFirstname = (state) => state.auth.firstname
export const selectCurrentUserDisplayname = (state) => state.auth.displayname
export const selectCurrentUserGuid = (state) => state.auth.guid
export const selectPermissions = (state) => state.auth.permissions
export const selectLicenseExpired = (state) => state.auth.licenseExpired
export const selectCompanyGuid = (state) => state.auth.company.guid
export const selectCompanyImg = (state) => state.auth.company.img
